import React, { useState, useEffect, useRef, FC  } from 'react';
import kemtapi from '@kemtai/skeleton-api';
import { Keypoints, GPU, modelConfig, tf } from  '@kemtai/skeleton-api';
import type { ModelInfo } from  '@kemtai/skeleton-api';
// import { drawFrame } from '@kemtai/skeleton-api';
import { getThreadsCount } from '@tensorflow/tfjs-backend-wasm';

import './style.css'
import {drawSkeleton} from './Visualize'
//import DiamondSkeleton from './DiamondSkeleton';
import CameraRecorder from './CameraRecorder';



const cameraRecorder = new CameraRecorder("skeleton-dev-tool");
//const diamondSkeleton = new DiamondSkeleton()

function RedCircle() {
    return (
        <div className='recording'>        
            <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25" cy="25" r="25" fill="red" />
            </svg>
        </div>
    )
}


function ModelInfoView (props:any) {
  const backend = tf.getBackend();
//   let mt = false;
//   let nt : number|string = "";
//   if (modelConfig.config) {
//     mt = tf.env().getBool('WASM_HAS_MULTITHREAD_SUPPORT')
//     if (backend === "wasm") {
//         //nt = getThreadsCount()  
//     }
//   }
  if (!props.modelInfo){
        return null
    }
    if (!props.FPS){
        return null
    }

    if (props.loading) {
        return <h3>MODEL:{props.modelInfo?.name} Loading ... </h3>
    } else {
       return  (<><h3>{backend}  MODEL:{props.modelInfo?.name} FPS:{Math.round(props.modelInfo.fps)} / {Math.round(props.modelInfo.time)}ms. </h3>
                  <h3>{props.FPS.chunk} | {Math.round(props.FPS.time)}ms. stddev={Math.round(props.FPS.stddev)} n={props.FPS.cntr.count} FPS:{Math.round(props.FPS.FPS)} </h3>
               </>)
    }
}


export type SkeletonProps = {
    videoSource? : string
}

export const Skeleton : FC<SkeletonProps>  = ({ videoSource : _videoSource = "camera" }) => {
  const canvasRef = useRef<HTMLCanvasElement|null>(null);
  const [models, setModels] = useState<string[]>([]);
  const [modelInfo, setModelInfo] = useState<ModelInfo>();
  const [selected, setSelected] = useState("automatic");
  const [recording, setRecording] = useState<boolean>(false);
  const [videoSource, setVideoSource] = useState<string>(_videoSource);



  const changeModel = async (e: any) => {
    setSelected(e.target.value);
    await kemtapi.skeleton.loadAllModels(e.target.value);
  }

  const toggleRecording = () => {
    console.log("toggleRecording>>> ", recording)
    setRecording((recording)=>!recording);
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.code === "Space" || event.keyCode === 32) {
      //event.preventDefault(); // prevent scrolling
      console.log("Spacebar pressed!");
      toggleRecording();
    }
  }
  

  const selectVideoSource = async (source:string) => {

    setVideoSource(source);
    if (source=== "camera") {
          const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
          kemtapi.setInputVideoStream(stream)
    } else {
        kemtapi.camera.setDebugVideo("https://app.kemtai.com/media/exercises/ad2e3321-81ce-5ae8-84bf-628149833cb1/640x480.mp4");
    }
  }

   const init = async () => {      
        // if (false) {
        //     kemtapi.camera.setDebugVideo("https://app.kemtai.com/media/exercises/ad2e3321-81ce-5ae8-84bf-628149833cb1/640x480.mp4");
        // } else {
        //     const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
        //     kemtapi.setInputVideoStream(stream)
        // }
        await selectVideoSource(videoSource)
        await kemtapi.loadModels()
        const disposer = kemtapi.registerFrameSkeletonCallback(updateSkeleton, "DrawSkeleton");
        getModels();
        document.addEventListener("keydown", handleKeyDown);


        return () => {
            disposer();
            document.removeEventListener("keydown", handleKeyDown);
        }
   }

  useEffect(() => {
    init();    
  }, []);

  useEffect(() => {
    console.log("useEffect>>> recording", recording)
    if (recording) {
        const stream = kemtapi.getStream()
        if (!stream) {
            console.log("No stream available for recording");
            setRecording(false);
            return;
        }
        cameraRecorder.start(stream);
    } else {
        cameraRecorder.stop();
    }
  }, [recording]);



  const getModels = async () => {
    const models = await modelConfig.allModels()
    setModels([...models , "automatic" , "slow"]);
  }


  const updateSkeleton = (kp:Keypoints|null, img : ImageBitmap|ImageData|null) => {
      //console.log("updateSkeleton>>>", kp===null);
      if (kemtapi.skeleton.modelInfo) {
        setModelInfo({...kemtapi.skeleton.modelInfo});
      }


    if (canvasRef.current ) {
        drawSkeleton(canvasRef.current, kp, img);
        /*
        drawFrame(canvasRef.current, img);
        diamondSkeleton.setContext(canvasRef.current.getContext("2d")!);
        if (kp) {
            diamondSkeleton.update(kp);
        }
        */
    }
  }

  const gpu = GPU()

  return (
    <div className="container">
        <div style={{position: 'relative'}}>
            <canvas  ref={canvasRef} height={480} width={640}></canvas>
            {recording && <RedCircle/>}
        </div>
        <div className='right-pannel'>
            
            <p>{gpu}<br/>{modelConfig._modelVer}  {modelConfig._modelBaseUrl}</p>
            <ModelInfoView FPS={kemtapi.skeleton.fpsHandler.FPS} modelInfo={modelInfo}></ModelInfoView>
            <select onChange={changeModel} value={selected}>
            {
                models.map(function(key) {
                    return <option value={key} key={key}>{key}</option>
                })
            }
            </select>
            <p> </p>

            <button onClick={toggleRecording}>
                <span style={{color:"red"}}>&nbsp; &#9673; &nbsp;</span>
                {recording ? "Stop" : "Start"} Recording</button>
            <p> </p>

            <select onChange={( e : any  ) => selectVideoSource(e.target.value)} value={videoSource}>
                <option value="camera" key="camera">camera</option>
                <option value="video" key="video">video</option>
            </select>
            <p> </p>

            <select onChange={( e : any  ) => kemtapi.changeBackend(e.target.value)} value={tf.getBackend()}>
                <option value="webgl" key="webgl">webgl</option>
                <option value="wasm" key="wasm">wasm</option>
            </select>


        </div>
    </div>   
  );

}